<template lang="pug">
.selection-group
  .d-flex.justify-content-between.p-4.border-bottom
    .h5.mb-0 {{title}}
    i.fa.fa-arrow-right.ml-auto(style='font-size: 24px; color: #1F93CA;')
  .sub-selection-group.p-0.border-bottom
    template(v-for="choice in choices")
      button.transparent-button.no-scaling.w-100.pl-4.pr-0(
        @click="onInput(choice.value)"
        :class="{'selected': value === choice.value}"
      )
        .d-inline.img-24: .check-container(:class="{'is-active': value === choice.value}")
          .check
        .choice-text.text-left.flex-fill.ml-3.h-100.py-3.pr-4 {{choice.text}}
      .mb-2.pl-5.ml-3(v-if="choice.hasExtraField && value === choice.value")
        InputWithIconSlot(
          :value="extraField"
          placeholder="ระบุ.."
          width="100%" @input="$emit('extraInput', $event)"
          :required='true'
        )
          i.fa.fa-pen
      .border-bottom.pl-5.ml-3
</template>

<script>
export default {
  props: ['value', 'choices', 'title', 'extraField'],
  methods: {
    onInput(value) {
      // when user select different choice -> clear the extra value
      if (value !== this.value) { this.$emit('extraInput', ''); }

      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss">
.selection-group {
  .sub-selection-group button {
    background: none;
    border: none;

    display: flex;
    align-items: center;
  }
  .sub-selection-group button:last-child {
    .choice-text {
      border: none;
    }
  }
}
</style>
